<script>
  import { format } from 'svelte-i18n';
  import { Button, ButtonGroup, Tooltip } from '@sveltestrap/sveltestrap';

  import { FilterBar } from '@client/components/filter-bar';
  import { Icon } from '@client/components/icon';

  export let view = 'list';
  export let onView = () => {};
  export let showFilters = false;
</script>

<div class="filter-bar">
  <FilterBar bind:show={showFilters}>
    <div class="filter-bar-content">
      <slot name="left" />

      <slot />

      <ButtonGroup size="sm" class="py-1">
        <Button id="user-layout-list" active={view === 'list'} on:click={() => onView('list')}>
          <Icon name="menu" />
          <span class="visually-hidden">{$format('label.LAYOUT_CONTROLS_LIST')}</span>
        </Button>
        <Tooltip target="user-layout-list">
          {$format('label.LAYOUT_CONTROLS_LIST')}
        </Tooltip>
        <Button id="user-layout-calendar" active={view === 'calendar'} on:click={() => onView('calendar')}>
          <Icon name="calendar" />
          <span class="visually-hidden">{$format('label.LAYOUT_CONTROLS_CALENDAR')}</span>
        </Button>
        <Tooltip target="user-layout-calendar">
          {$format('label.LAYOUT_CONTROLS_CALENDAR')}
        </Tooltip>
      </ButtonGroup>
    </div>
  </FilterBar>
</div>

<style lang="scss">
  .filter-bar {
    background-color: var(--color-white);
    box-shadow:
      0 20px 0 0 var(--color-white),
      0 -16px 0 0 var(--color-white);
    position: sticky;
    top: 0;
    z-index: 21;
  }

  .filter-bar-content {
    align-items: center;
    display: flex;
    gap: 8px;

    :global(.btn-group .btn) {
      font-size: var(--font-size-base);
      padding: calc(var(--padding-base) - 3px) calc(var(--padding-base) + 2px);

      &:first-child {
        border-radius: var(--border-radius-base) 0 0 var(--border-radius-base);
      }

      &:last-child {
        border-radius: 0 var(--border-radius-base) var(--border-radius-base) 0;
      }
    }

    :global(> span) {
      flex: 1;
    }
  }

  @media only screen and (max-width: 600px) {
    .filter-bar-content {
      align-items: flex-start;
      border-bottom: 1px solid var(--border-color);
      margin-bottom: var(--margin-large);
      display: grid;
      gap: var(--margin-base);
      grid-template-columns: 1fr 1fr;
      padding-bottom: var(--padding-base);
      position: sticky;

      :global(> *) {
        grid-column: span 2;
      }
    }
  }
</style>
